import { gql } from 'apollo-boost';
import { INTERACTIVE_MESSAGE_FIELDS } from '../../fragments/message/interactive-message-fields';

export const GET_FOLDER_CONTENT = gql`
    query($data: GetFolderContentInput!) {
        getFolderContent(data: $data, trackView: true) {
            viewerCanCreateSubfolders
            viewerCanAdd
            viewerCanContribute
            folder {
                id
                title
                parent
                before
                owner
                isPinned
                pinnedRank
                deletedAt
                lastViewedAt
                lastMovedAt
                manualMessageSortEnabled
                sharingStatus {
                    isShared
                    shareCount
                    isPublished
                }
            }
            parent {
                id
                title
                parent
                before
                owner
                isPinned
                pinnedRank
                deletedAt
                lastViewedAt
                lastMovedAt
                sharingStatus {
                    isShared
                    shareCount
                    isPublished
                }
            }
            folders {
                id
                title
                parent
                before
                owner
                isPinned
                pinnedRank
                deletedAt
                lastViewedAt
                lastMovedAt
                manualMessageSortEnabled
                sharingStatus {
                    isShared
                    shareCount
                    isPublished
                }
            }
            path {
                id
                title
                parent
                before
                owner
                isPinned
                pinnedRank
                deletedAt
                lastViewedAt
                lastMovedAt
                sharingStatus {
                    isShared
                    shareCount
                    isPublished
                }
            }
            messages {
                messages {
                    ${INTERACTIVE_MESSAGE_FIELDS}
                }
                cursor
                hasOlderMessages
                hasNewerMessages
                targetMessageId
            }
        }
    }
`;
